import React from 'react';
import OtpVerificationPageWithImage from 'app/Components/Shared/OtpAuthentication/OtpVerificationPageWithImage';
import {
  stepEnum,
  setCurrentStep,
  setSelectedPhoneNumber,
  startPointEnum,
  validateAccountToIMEIService,
  getSubscriberList,
} from 'app/Components/Block/IMEIDeviceRepairBlock/IMEIDeviceRepairSlice';
import {connect} from 'react-redux';
import {otpOrigin} from 'app/Components/Block/OTPLoginBlock/Assets/variables';
const OtpStep = (props, contentData) => {
  const otpTitles = {
    verifyPhoneTitle: 'תיאום שליחות לתיקון מכשיר',
    verifyPhoneDescription: 'מה מספר הנייד שלכם?',
    phoneStepButtonText: '',
    verifyCodeTitle: '',
    verifyCodeDescription: '',
    otpCodeStepButtonText: '',
  };

  const onAuthentication = async () => {
    props.setSelectedPhoneNumber(props.loginData.userDetails.contactNumber);

    if (!props.loginData.isOtpAuthenticated) {
      await props.getSubscriberList().then(async (res) => {
        if (res.payload?.data?.length > 1) {
          setCurrentStep(stepEnum.SELECT_SUBSCRIBER);
        } else {
          let validationParams = {
            startPoint: props.deviceRepairData.startPoint,
            selectedNumber: props.loginData.userDetails.contactNumber,
            selectedIMEI: props.deviceRepairData.form.imei,
            isPrivate: props.deviceRepairData?.isPrivate,
            isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value == true,
          };

          const result = await props.validateAccountToIMEIService(validationParams);

          if (!result.payload.error) {
            setCurrentStep(stepEnum.SELECT_IMEI);
          } else {
            setCurrentStep(stepEnum.VALIDATION);
          }
        }
      });
    }

    let validationParams = {
      startPoint: props.deviceRepairData.startPoint,
      selectedNumber: props.loginData.userDetails.contactNumber,
      selectedIMEI: props.deviceRepairData.form.imei,
      isPrivate: props.deviceRepairData?.isPrivate,
      isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value == true,
    };

    const result = await props.validateAccountToIMEIService(validationParams);
    if (!result.payload.error) {
      props.setCurrentStep(stepEnum.SELECT_IMEI);
    }
  };
  return <OtpVerificationPageWithImage otpTitles={otpTitles} onAuthenticatedAction={onAuthentication} isInline={false} />;
};
const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair, portalState: state.portalsBlock, loginData: state.authentication.loginData};
};

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedPhoneNumber,
  validateAccountToIMEIService,
  getSubscriberList,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpStep);
